import React, { useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import sal from "sal.js";
import { Helmet } from "@dr.pogodin/react-helmet";


export default function AWS() {
  useEffect(() => {
    document.title = "AWS Hosting Services | Scalable Cloud Solutions";
      sal();
    }, []);
  return (
    <>
    <Helmet>
        <title>AWS Hosting Services | Scalable Cloud Solutions</title>
        <meta name="description" content="Get fully managed AWS hosting with high availability, secure infrastructure, and optimized performance for startups and enterprises." />
        <meta name="keywords" content="AWS Cloud Hosting, AWS Web Hosting, Amazon Hosting, Amazon Web Hosting, AWS Website Hosting, Amazon Cloud Hosting, AWS Wordpress Hosting, Amazon Cloud Server Hosting, AWS Hosting" />
        <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/aws-cloud-hosting`} />
        <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/aws-cloud-hosting`} />
        <meta property="og:title" content="Managed AWS Cloud Hosting | Best AWS Hosting Provider" />
        <meta property="og:description" content="Infinitive Host believes in providing AWS cloud hosting at affordable prices. You can scale your business further as we manage the cloud hosting server." />
    </Helmet>
      <section className="banner-bg bg-dark ssl-banner">
        <div className="container">
            <div className="row align-items-center g-4">
              <div className="col-lg-6">
                  <div className="pb-40">
                    <span className="fs-18 fw-bold text-primary mb-2 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Your Go-To Provider for Hosting</span>
                    <h1 className="text-white mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Let Our AWS Cloud Hosting Handle the Hustle</h1>
                    <p className="text-white mb-8 max-text-60 text-opacity-75 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">It always begins with just a tiny lag. Then a huge bounce. Your dream tasks? Losing all quality clicks, losing users' trust. But what if your website didn’t have to fight to be live? What if AWS cloud hosting quietly did all the heavy lifting while you kept growing louder?</p>
                    <button className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded sal-animate open-live-chat btn-height" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine" data-discover="true">
                      <span className="btn-arrow__text">Talk to an Expert
                        <span className="btn-arrow__icon">
                          <i className="fa-solid fa-arrow-right"></i>
                        </span>
                      </span>
                    </button>
                  </div>
              </div>
              <div className="col-lg-6 col-xxl-6 ipad-mt">
                  <div className="cloud-hero__img sal-animate" data-sal="fade" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine"><img alt="image" className="img-fluid full-width-img" src="/images/every-site-has-a-unique-story.webp" /></div>
              </div>
            </div>
        </div>
      </section>
      <div className="responsive-pt-60 pb-100 linux-hosting-points-section">
        <div className="pb-60">
            <div className="container">
              <div className="row g-4 align-items-center justify-content-xl-between">
                  <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded"><span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>New Chapter of Your Site</small>
                    <h2 className="mb-4">New Website. AWS Cloud Hosting That Shows Up Every Time</h2>
                    <p className="max-text-56 mb-0 fw-semibold">You’ve done the most difficult part, which is dreaming it, building it, and growing up. Let AWS Cloud hosting by Infinitive Host take it from right here.</p>
                  </div>
                  <div className="col-lg-6 col-xl-5 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="card">
                        <div className="card-body cloud-hosting-vid-card">
                                <div className="features-video position-relative z-1">
                                    <img src="/images/infi-common-video-yt-thumb.jpg" alt="image" className="img-fluid w-100"/>
                                    <Link to="https://youtu.be/x10KM9gI110?si=kVgGnbSAsh-zfKn7" target="_blank" className="btn gradient-bg w-15 h-15 d-grid place-content-center rounded-circle position-absolute top-50 start-50 translate-middle fs-24 text-white popup-init">
                                        <i className="fa-solid fa-play"></i>
                                    </Link>
                                </div>
                            </div>
                    </div>
                  </div>
              </div>
            </div>
        </div>
        <div className="container">
            <div className="row g-4">
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/no-slow-speeds-just-10-Gbps.webp" /></div>
                        <h6 className="mb-4">Speed, Unlocked.</h6>
                        <p className="mb-0">Get blazing-fast performance with our pre-planned AWS hosting stack. From robust servers to advanced caching, everything’s set up to keep your website running efficiently.</p>
                    </div>
                  </div>
              </div>
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/teamwork-sorted.webp" /></div>
                        <h6 className="mb-4">Teamwork, Sorted.</h6>
                        <p className="mb-0">Allocate roles, track complete progress, and handle everything in one place-our cloud hosting supports collaboration so your team stays aligned and in full control.</p>
                    </div>
                  </div>
              </div>
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/no-bots-just-our.webp" /></div>
                        <h6 className="mb-4">No Bots. Just Our Experts.</h6>
                        <p className="mb-0">No bots. No long wait lines. Just true professionals, available 24×7 to fix what’s really broken, answer what’s confusing, and guide you whenever you want to.</p>
                    </div>
                  </div>
              </div>
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/code-click-done.webp" /></div>
                        <h6 className="mb-4">Code. Click. It’s Done.</h6>
                        <p className="mb-0">Skip all the manual setup hassle. Our AWS web hosting simply automates all your application deployment so you can effortlessly build, scale, and grow without any struggle.</p>
                    </div>
                  </div>
              </div>
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/growing-on-a-budget.webp" /></div>
                        <h6 className="mb-4">Growing on a budget?</h6>
                        <p className="mb-0">Our budget-friendly AWS hosting solutions always help you save smart-with well-optimized resources, blazing-fast performance, and unexpected compromise.</p>
                    </div>
                  </div>
              </div>
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/oops-proof-storage.webp" /></div>
                        <h6 className="mb-4">No Oops, More Output</h6>
                        <p className="mb-0">With the help of our managed AWS cloud hosting, you can comfortably sit back and just relax. We manage everything, from monitoring to issue resolution, so your cloud runs 24/7.</p>
                    </div>
                  </div>
              </div>
            </div>
        </div>
      </div>
      <section className="pb-100">
        <div className="container">
            <div className="bg-white px-8 py-10 rounded-3">
                <div className="row align-items-center g-4">
                    <div className="col-lg-5">
                        <img src="/images/unmetered-mitigation.webp" alt="image" className="img-fluid sal-animate full-width-img" data-sal="fade" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine"/>
                    </div>
                    <div className="col-lg-7 ipad-mt">
                        <div className="d-inline-flex align-items-center gap-2 mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded">
                              <span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>Freedom to Grow
                            </small>
                        </div>
                        <h2 className="mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">AWS: Because Your Business Hates Unnecessary Limits</h2>
                        <p className="mb-0 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine"> Sick of slow setups and instant traffic growth? AWS cloud hosting helps you scale quickly, stay trustworthy, and grow without infrastructure issues, so you can focus completely on your brand, not your servers</p>
                        <Link to="/contact-us" className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded sal-animate mt-5 btn-height" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                              <span className="btn-arrow__text">
                                  Free Trial
                                  <span className="btn-arrow__icon">
                                      <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                              </span>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
      </section>

      <section>
        <div className="container">
            <div className="row">
                <div className="col-lg-8">
                    <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded">
                        <span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>Features
                    </small>
                    <h4 className="pb-3">Why is Everyone Suddenly Moving to the Infinitive Host? Here’s the AWS Hosting Tea.</h4>
                </div>
            </div>
          <div className="table-responsive">
            <table className="table aws-cloud-feature-table table-bordered table-hover">
                <thead className="thead-dark">
                    <tr>
                        <th style={{ width: "50%", paddingLeft: "20px", textAlign: "left" }}>Feature</th>
                        <th style={{ width: "25%", textAlign: "center" }}>AWS</th>
                        <th style={{ width: "25%", textAlign: "center" }}>Infinitivehost Managed AWS</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style={{ paddingLeft: "20px" }}>24/7 Chat &amp; Ticket Support</td>
                        <td className="text-center text-danger"><small><small><i className="fa fa-x"></i></small></small></td>
                        <td className="text-center text-success"><small><small><i className="fa fa-check"></i></small></small></td>
                    </tr>
                    <tr>
                        <td style={{ paddingLeft: "20px" }}>Optimized Stack </td>
                        <td className="text-center text-danger"><small><i className="fa fa-x"></i></small></td>
                        <td className="text-center text-success"><small><i className="fa fa-check"></i></small></td>
                    </tr>
                    <tr>
                        <td style={{ paddingLeft: "20px" }}>Dedicated Firewalls </td>
                        <td className="text-center text-danger"><small><i className="fa fa-x"></i></small></td>
                        <td className="text-center text-success"><small><i className="fa fa-check"></i></small></td>
                    </tr>
                    <tr>
                        <td style={{ paddingLeft: "20px" }}>Free SSL Certificates</td>
                        <td className="text-center text-danger"><small><i className="fa fa-x"></i></small></td>
                        <td className="text-center text-success"><small><i className="fa fa-check"></i></small></td>
                    </tr>
                    <tr>
                        <td style={{ paddingLeft: "20px" }}>Managed Backups </td>
                        <td className="text-center text-danger"><small><i className="fa fa-x"></i></small></td>
                        <td className="text-center text-success"><small><i className="fa fa-check"></i></small></td>
                    </tr>
                    <tr>
                        <td style={{ paddingLeft: "20px" }}>All PHP Apps Supported</td>
                        <td className="text-center text-success"><small><i className="fa fa-check"></i></small></td>
                        <td className="text-center text-success"><small><i className="fa fa-check"></i></small></td>
                    </tr>
                    <tr>
                        <td style={{ paddingLeft: "20px" }}>Unlimited Staging Areas </td>
                        <td className="text-center text-danger"><small><i className="fa fa-x"></i></small></td>
                        <td className="text-center text-success"><small><i className="fa fa-check"></i></small></td>
                    </tr>
                    <tr>
                        <td style={{ paddingLeft: "20px" }}>Built-in Advanced Cache </td>
                        <td className="text-center text-danger"><small><i className="fa fa-x"></i></small></td>
                        <td className="text-center text-success"><small><i className="fa fa-check"></i></small></td>
                    </tr>
                    <tr>
                        <td style={{ paddingLeft: "20px" }}>Built-in CDN</td>
                        <td className="text-center text-danger"><small><i className="fa fa-x"></i></small></td>
                        <td className="text-center text-success"><small><i className="fa fa-check"></i></small></td>
                    </tr>
                    <tr>
                        <td style={{ paddingLeft: "20px" }}>SSD-Based Servers</td>
                        <td className="text-center text-success"><small><i className="fa fa-check"></i></small></td>
                        <td className="text-center text-success"><small><i className="fa fa-check"></i></small></td>
                    </tr>
                    <tr>
                        <td style={{ paddingLeft: "20px" }}>Server &amp; App Monitoring (15+ Metrics)</td>
                        <td className="text-center text-danger"><small><i className="fa fa-x"></i></small></td>
                        <td className="text-center text-success"><small><i className="fa fa-check"></i></small></td>
                    </tr>
                    <tr>
                        <td style={{ paddingLeft: "20px" }}>1-Click Server Cloning</td>
                        <td className="text-center text-danger"><small><i className="fa fa-x"></i></small></td>
                        <td className="text-center text-success"><small><i className="fa fa-check"></i></small></td>
                    </tr>
                    <tr>
                        <td style={{ paddingLeft: "20px" }}>Managed Website Migration</td>
                        <td className="text-center text-danger"><small><i className="fa fa-x"></i></small></td>
                        <td className="text-center text-success"><small><i className="fa fa-check"></i></small></td>
                    </tr>
                    <tr>
                        <td style={{ paddingLeft: "20px" }}>Built-in MySQL Manager</td>
                        <td className="text-center text-danger"><small><i className="fa fa-x"></i></small></td>
                        <td className="text-center text-success"><small><i className="fa fa-check"></i></small></td>
                    </tr>
                    <tr>
                        <td style={{ paddingLeft: "20px" }}>1-Click App Install </td>
                        <td className="text-center text-danger"><small><i className="fa fa-x"></i></small></td>
                        <td className="text-center text-success"><small><i className="fa fa-check"></i></small></td>
                    </tr>
                    <tr>
                        <td style={{ paddingLeft: "20px" }}>Availability of Multiple Cloud Providers</td>
                        <td className="text-center text-danger"><small><i className="fa fa-x"></i></small></td>
                        <td className="text-center text-success"><small><i className="fa fa-check"></i></small></td>
                    </tr>
                    <tr>
                        <td style={{ paddingLeft: "20px" }}>3-Day Free Trial</td>
                        <td className="text-center text-danger"><small><i className="fa fa-x"></i></small></td>
                        <td className="text-center text-success"><small><i className="fa fa-check"></i></small></td>
                    </tr>
                    <tr>
                        <td style={{ paddingLeft: "20px" }}>Account Management Dashboard</td>
                        <td className="text-center text-success"><small><i className="fa fa-check"></i></small></td>
                        <td className="text-center text-success"><small><i className="fa fa-check"></i></small></td>
                    </tr>
                    <tr>
                        <td style={{ paddingLeft: "20px" }}>Easy DNS Management</td>
                        <td className="text-center text-danger"><small><i className="fa fa-x"></i></small></td>
                        <td className="text-center text-success"><small><i className="fa fa-check"></i></small></td>
                    </tr>
                    <tr>
                        <td style={{ paddingLeft: "20px" }}>1-Click Advanced Server Management</td>
                        <td className="text-center text-danger"><small><i className="fa fa-x"></i></small></td>
                        <td className="text-center text-success"><small><i className="fa fa-check"></i></small></td>
                    </tr>
                    <tr>
                        <td style={{ paddingLeft: "20px" }}>Easy Application Management</td>
                        <td className="text-center text-danger"><small><i className="fa fa-x"></i></small></td>
                        <td className="text-center text-success"><small><i className="fa fa-check"></i></small></td>
                    </tr>
                    <tr>
                        <td style={{ paddingLeft: "20px" }}>Easy SSL Installation &amp; Auto Renewal</td>
                        <td className="text-center text-danger"><small><i className="fa fa-x"></i></small></td>
                        <td className="text-center text-success"><small><i className="fa fa-check"></i></small></td>
                    </tr>
                    <tr>
                        <td style={{ paddingLeft: "20px" }}>App Backup Support</td>
                        <td className="text-center text-danger"><small><i className="fa fa-x"></i></small></td>
                        <td className="text-center text-success"><small><i className="fa fa-check"></i></small></td>
                    </tr>
                </tbody>
            </table>
        </div>
        </div>
      </section>
      <div className="pt-60 pb-60">
        <div className="pb-60">
            <div className="container">
                <div className="row g-4 align-items-center">
                    <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <img src="images/lift-off-to-our-hosting.webp" alt="image" className="img-fluid" />
                    </div>
                    <div className="col-md-6">
                        <div className="ps-lg-8 pe-xxl-12">
                            <span className="d-block mb-2 text-primary fs-18 fw-semibold sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Migrate Your Site & Take The Lead
                            </span>
                            <h3 className="mb-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Lift Off to Our Hosting: We Manage the Takeoff
                            </h3>
                            <p data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine" className="sal-animate">
                                No worries, no unexpected downtime, and no headaches. We shift your site to our AWS hosting for FREE-all source files, resources, and the chill vibe. Let our experts manage the heavy lifting while you sit, relax, and focus only on scaling. Because smooth moves deserve robust hosting.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="pb-60">
            <div className="container">
                <div className="row g-4 align-items-center">
                    <div className="col-md-6">
                        <div className="ps-lg-8 pe-xxl-12">
                            <span className="d-block mb-2 text-primary fs-18 fw-semibold sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Your Website, Back to Life
                            </span>
                            <h3 className="mb-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Your Site Called… It’s Sick of Playing Dead.
                            </h3>
                            <p data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine" className="sal-animate">
                                Your brand is not just basic, so why always settle for lazy hosting? Give your website the cloud glow-up it actually deserves with AWS web hosting that stays available no matter what. We always keep your digital hustle up, alert, and always serving. No more crashes. No “oops.”
                            </p>
                        </div>
                    </div>
                    <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <img src="images/your-site-called.webp" alt="image" className="img-fluid" />
                    </div>
                </div>
            </div>
        </div>
      </div>
      <section>
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-xxl-7 col-xl-8">
                    <div className="d-flex align-items-center justify-content-center gap-2 mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <small className="d-inline-block mb-2 fw-bold bg-primary-subtle text-primary-emphasis border border-primary-subtle px-3 py-1 rounded">
                            <span className="d-inline-block w-2 h-2 bg-primary rounded-circle me-1"></span>Budget-Friendly Solutions, Just For You
                        </small>
                    </div>
                    <div className="text-center mb-8">
                        <h2 className="text-dark mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Fast? Yes, Infinitive Host’s AWS Hosting Has Everything.</h2>
                    </div>
                </div>
            </div>
            <div className="row g-4">
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 p-xl-10 rounded-3 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">1 Click, 0 Headache</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">01</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/one-click-endless.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Want to set up AWS cloud hosting? Just a single click and it’s completely done. We install your app on AWS-quick, clean, and free of setup costs.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Tried. Tested. Trusted.</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">02</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/lock-a-trust-badge.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Opting for cloud hosting, you can easily count on it. We deliver secure, advanced AWS cloud hosting-powered by support that never lets you down.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">No Weak Links Here</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">03</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/no-weak-links-here.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Our AWS hosting runs on powerful infrastructure managed 24/7 by our expert team, so all of your servers stay powerful, stable, and secure.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Cloud That Adjusts</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">04</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/cloud-command.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Our AWS cloud hosting always grows with you whenever you want. We have studied all user pain points to build smarter, more flexible plans.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </section>
      <section className="simple-box-section pt-100 pb-100">
        <div className="container">
          <div className="row">
              <div className="col-12">
                  <div className="card rounded-3 cta-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                      <div className="card-body px-6 pt-60 pb-60">
                          <div className="row justify-content-center">
                              <div className="col-md-11 col-lg-8 col-xl-8">
                                  <div className="text-center">
                                    <span className="section-title style-bg fadeInUp mb-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">99.9% Uptime?? All the Time.</span>
                                      <h4 className="mb-4">
                                          AWS Cloud Hosting: Cold Uptime. Hot Performance.
                                      </h4>
                                      <p className="mb-6">
                                        Your website could be running 3 times faster right now-and you wouldn’t even know it. Harness the complete potential of AWS cloud hosting, without even lifting a finger. All set to get what lightning fast really feels like? 
                                      </p>
                                      <Link to="tel:7737300013" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded me-sm-2 btn-height">
                                          <span className="d-inline-block me-1 flex-shrink-0">
                                              <i className="las la-comments"></i>
                                          </span>
                                          <span className="btn-arrow__text">
                                              +91-7737300013
                                              <span className="btn-arrow__icon">
                                                  <i className="fa-solid fa-arrow-right"></i>
                                              </span>
                                          </span>
                                      </Link>
                                      <Link to="#" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded ms-sm-2 mt-sm-0 mt-4 open-live-chat btn-height">
                                          <span className="d-inline-block me-1 flex-shrink-0">
                                              <i className="las la-comments"></i>
                                          </span>
                                          <span className="btn-arrow__text">
                                              Talk to an Expert
                                              <span className="btn-arrow__icon">
                                                  <i className="fa-solid fa-arrow-right"></i>
                                              </span>
                                          </span>
                                      </Link>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
      </section>
    </>
  );
}
